module.exports = __webpack_public_path__ + "static/media/portfolio.c20d9901.jpg";